// Lógica pura (sin JSX/React) extraída de DownloadButtomAllDataNew.jsx
// (camposAdicionalesModalidad(), antes mezclada con la construcción de las
// columnas HTML/CSV del export) — arma la lista combinada de TODOS los
// campos de inscripción: los del formulario base
// (registryConfiguration.formulario) más los agregados por modalidad
// (eventSubEventsRegistry[modalidad_X].configModalidad.camposAdicionalesModalidad),
// deduplicados por iDCampo dentro de los campos por modalidad (mismo
// criterio que ya tenía el código original — no dedupea entre formulario
// base y modalidad, se preserva tal cual para no cambiar el comportamiento
// existente del export CSV que ya usa esta lógica).
export function getCamposAdicionalesModalidad(
  registryConfiguration,
  eventSubEventsRegistry
) {
  const campos = [];

  const formulario = (registryConfiguration && registryConfiguration.formulario) || {};
  for (var i in formulario) {
    if (formulario[i].tipoCampo != "titulo") {
      campos.push(formulario[i]);
    }
  }

  const modalidadesBuscar = eventSubEventsRegistry || {};
  const arrayCampoModalidad = [];

  for (var mod in modalidadesBuscar) {
    var modalidadCampos =
      modalidadesBuscar[mod].configModalidad &&
      modalidadesBuscar[mod].configModalidad.camposAdicionalesModalidad;
    if (modalidadCampos != undefined) {
      for (var e in modalidadCampos) {
        var camposGrupo = modalidadCampos[e];
        for (var f in camposGrupo) {
          if (camposGrupo[f].tipoCampo != "titulo") {
            if (!arrayCampoModalidad.includes(camposGrupo[f].iDCampo)) {
              arrayCampoModalidad.push(camposGrupo[f].iDCampo);
              campos.push(camposGrupo[f]);
            }
          }
        }
      }
    }
  }

  return campos;
}

// Productos adicionales configurados en cualquier modalidad del evento
// (eventSubEventsRegistry[modalidad_X].configModalidad.productosAdicionales),
// deduplicados por codigoProducto — mismo criterio de recolección que ya
// usa DashboardContainer.jsx para armar jsonDashboard.productos.
export function getCamposProductos(eventSubEventsRegistry) {
  const productos = [];
  const vistos = [];
  const modalidadesBuscar = eventSubEventsRegistry || {};

  for (var mod in modalidadesBuscar) {
    var modalidadProductos =
      modalidadesBuscar[mod].configModalidad &&
      modalidadesBuscar[mod].configModalidad.productosAdicionales;
    if (modalidadProductos != undefined) {
      for (var e in modalidadProductos) {
        var producto = modalidadProductos[e];
        if (producto && producto.codigoProducto != undefined && !vistos.includes(producto.codigoProducto)) {
          vistos.push(producto.codigoProducto);
          productos.push(producto);
        }
      }
    }
  }

  return productos;
}
